<template>
  <div id="app">
    <div class="view-container">
      <BaseNav/>
      <transition
        mode="out-in"
        @leave="leave"
        @enter="enter">
        <router-view
          class="view"
          ref="view"
          @start-audio="startAudio"
        />
      </transition>
      <BaseBackground/>
      <BaseBackgroundFlare/>
      <BaseBackgroundMusic ref="background-music"/>
    </div>
  </div>
</template>

<script>
import BaseNav from '@/components/BaseNav/BaseNav'
import BaseBackground from '@/components/BaseBackground/BaseBackground'
import BaseBackgroundFlare from '@/components/BaseBackgroundFlare/BaseBackgroundFlare'
import BaseBackgroundMusic from '@/components/BaseBackgroundMusic/BaseBackgroundMusic'
import { TimelineMax, Power2 } from 'gsap'
import preload from '@/utils/preload'
export default {
  components: {
    BaseNav,
    BaseBackground,
    BaseBackgroundFlare,
    BaseBackgroundMusic
  },
  watch: {
    $route () {
      this.from = this.$refs['view']
    }
  },
  methods: {
    async enter (_, done) {
      const tl = new TimelineMax({ paused: true, onComplete: done })
      tl.fromTo(this.$refs['view'].$el, 1, { autoAlpha: 0 }, { autoAlpha: 1, ease: Power2.easeInOut })
      await preload(this.$refs['view'].$el)
      if (this.$refs['view'].animateIn) this.$refs['view'].animateIn()
      tl.play()
    },
    async leave (_, done) {
      const tl = new TimelineMax({ onComplete: done })
      tl.to(this.from.$el, 0.5, { autoAlpha: 0, ease: Power2.easeInOut })
    },
    startAudio () {
      this.$refs['background-music'].play()
    }
  }
}
</script>

<style lang="scss" scoped>
#app {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.view-container {
  position: relative;
  // width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
}
.view {
  padding: var(--spacing-1);
  will-change: opacity;
}
</style>
